/* eslint-disable import/no-extraneous-dependencies */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createProxy", {
    enumerable: true,
    get: function() {
        return createProxy;
    }
});
const _server = require("react-server-dom-webpack/server");
const createProxy = _server.createClientModuleProxy;

//# sourceMappingURL=module-proxy.js.map